import { apiClient } from '@/core/api/client';

export type ReferralLinkResponse = {
  referralCode: string;
  referralLink: string;
};

/**
 * Fetches the signed-in pro's referral link.
 *
 * `/invites/referral-link` is role-agnostic — it answers for a Financial
 * Advisor and a Service Provider alike — so this lives in `shared` rather than
 * in either dashboard. The two dashboard modules kept their own byte-identical
 * copies of this call and now delegate here; anything outside a dashboard
 * should import this one directly rather than reaching across features.
 */
export const fetchReferralLink = async (): Promise<ReferralLinkResponse> => {
  const response = await apiClient.get<ReferralLinkResponse>('/invites/referral-link');
  return response.data;
};
